import React from 'react'
import PropTypes from 'prop-types'

import {
  Box, Text, UserProfileImage,
} from '@campaignhub/suit-theme'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser } from '@fortawesome/pro-light-svg-icons'

const IconProfile = (props) => {
  const {
    imageUrl, name, position, contactNo, email,
  } = props

  return (
    <Box flexDirection="row" alignItems="center">
      <UserProfileImage imageUrl={imageUrl}>
        <FontAwesomeIcon icon={faUser} />
      </UserProfileImage>
      <Box flexDirection="column" paddingLeft="large">
        <Text fontSize="small">
          {name}
        </Text>
        <Text color="bodyFontLightColor" fontSize="xsmall" paddingTop={position ? 'small' : 0}>
          {position}
        </Text>
        <Text color="bodyFontLightColor" fontSize="xsmall" paddingTop={contactNo ? 'small' : 0}>
          {contactNo}
        </Text>
        <Text color="bodyFontLightColor" fontSize="xsmall" paddingTop={email ? 'small' : 0}>
          {email}
        </Text>
      </Box>
    </Box>
  )
}

IconProfile.propTypes = {
  imageUrl: PropTypes.string,
  name: PropTypes.string,
  position: PropTypes.string,
  contactNo: PropTypes.string,
  email: PropTypes.string,
}

export default IconProfile
